import { BaseAnnotationControl } from "@/viewer/BaseAnnotationControl";
import Select from "ol/interaction/Select";
import { click } from "ol/events/condition";

export default class SelectControl extends BaseAnnotationControl {
  constructor({
    target = null,
    element = null,
    source = null,
    callback = null,
    layer = null
  }) {
    super({
      target,
      element,
      source,
      layer
    });
    const interaction = new Select({
      source,
      layer: [layer],
      hitTolerance: 3,
      condition: click
    });
    const _this = this;
    interaction.on("select", evt => {
      callback(evt, _this);
    });
    super.interaction = interaction;
  }

  activate() {
    super.activate();
    super.map.getViewport().style.cursor = "pointer";
    // this.map.on("pointermove", this.hoverFeatures);
  }

  deactivate() {
    super.deactivate();
    // this.map.on("pointermove", this.hoverFeatures);
  }
}
